import { brotliDecompressSync } from "zlib";

let body = document.body;

let hamburger = document.querySelector(".hamburger");
body = document.querySelector("body");

hamburger.addEventListener("click", e => {
    e.preventDefault();
    body.classList.toggle("nav_open");
});

let closeNoticeProduct = document.querySelector(".product-close");
body = document.querySelector("body");

if (closeNoticeProduct) {
    closeNoticeProduct.addEventListener("click", e => {
        e.preventDefault();
        body.classList.toggle("hide-notice-product");
    });
}
let closeNotice = document.querySelector(".close-notice");
body = document.querySelector("body");

if (closeNotice) {
    closeNotice.addEventListener("click", e => {
        e.preventDefault();
        body.classList.toggle("hide-notice");
    });
}
